import { Component } from "@angular/core";

@Component({
  selector: "ab-spinner",
  templateUrl: "./spinner.component.html",
})
export class SpinnerComponent {}
